import VerifyLinkContainer from "./VerifyLinkContainer";
import VerifyLinkStore from "./VerifyLinkStore";
export default VerifyLinkStore(VerifyLinkContainer);